import { Webinar } from '@anm/api/modules/hosting';
import { ChangeEvent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { landingsActions } from '../../../../store/modules/landings';

const useWebinarPageElements = (webinar: Webinar) => {
  const dispatch = useDispatch();

  const { chat: isChat, showOnDemand, showCommentsOnDemand } = webinar.parameters;
  const canShowCommentsOnDemand = isChat && showOnDemand;

  const onShowOnDemandToggle = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        landingsActions.updateLanding({
          ...webinar,
          parameters: {
            ...webinar.parameters,
            meta: {
              ...webinar.parameters.meta
            },
            showOnDemand: e.target.checked
          }
        })
      );
    },
    [webinar]
  );

  const onShowCommentsOnDemandToggle = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        landingsActions.updateLanding({
          ...webinar,
          parameters: {
            ...webinar.parameters,
            meta: {
              ...webinar.parameters.meta
            },
            showCommentsOnDemand: e.target.checked
          }
        })
      );
    },
    [webinar]
  );

  return [
    showOnDemand,
    onShowOnDemandToggle,
    isChat,
    showCommentsOnDemand,
    canShowCommentsOnDemand,
    onShowCommentsOnDemandToggle
  ] as const;
};

export default useWebinarPageElements;
